<template>
	<div>
		<employee-awards-list />
	</div>
</template>
<script>
import employeeAwardsList from '@/components/awards/employee-awards-list';

export default {
	name: 'page-employee-awards',
	components: {
		employeeAwardsList,
	},
};
</script>
<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/pages/awards/page-employee-awards.vue